<template>
  <transition name="modal" class="modal-open">
    <div v-if="valueData" ref="modal-generica">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div :style="[customStyle, propStyle]" class="modal-container">
                      <div v-if="close" @click="$emit('input', false)">
                        <icon class="close-icon" name="x" :size="20"/>
                      </div>
                      <slot name="all">
                        <div class="modal-header">
                          <slot name="header">
                              default header
                          </slot>
                        </div>

                        <div class="modal-body">
                          <slot name="body">
                              default body
                          </slot>
                        </div>

                        <div class="modal-footer">
                          <slot name="footer">
                                  default footer
                              <button class="modal-default-button" @click="$emit('input', false)">
                                  OK
                              </button>
                          </slot>
                        </div>
                      </slot>
                    </div>
                </div>
            </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true
    },
    width: {
      type: Number,
      default: 100,
      required: false
    },
    close: {
      type: Boolean,
      default: false
    },
    propStyle: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      valueData: this.value,
      hidden: false
    }
  },
  watch: {
    value () {
      this.valueData = this.value
    },
    valueData () {
      let overflow = document.documentElement.style.overflow
      if (!this.valueData) {
        if (overflow === 'hidden auto') {
          this.hidden = false
        } else {
          document.documentElement.style.overflow = 'hidden auto'
        }
      } else {
        if (overflow === 'hidden') {
          this.hidden = true
        } else {
          document.documentElement.style.overflow = 'hidden'
        }
      }
    }
  },
  computed: {
    customStyle () {
      return {
        'width': this.width + 'px'
      }
    }
  }
}
</script>

<style lang="sass" scoped>
$headerColor: #42b983

.modal-mask
  position: fixed
  z-index: 11111111
  top: 0
  left: 0
  width: 100%
  height: 100%
  background-color: rgba(0, 0, 0, .3)
  display: flex
  transition: opacity .3s ease

.modal-wrapper
  justify-content: center
  align-content: center
  align-items: center
  height: 100%
  width: 100%
  position: fixed
  display: flex

.modal-container
  width: 100%
  max-height: 95%
  height: auto
  margin: 26px
  background-color: #fff
  border-radius: 20px
  box-shadow: 0 2px 8px rgba(0, 0, 0, .22)
  transition: all .3s ease
  position: relative
  overflow-y: auto
  overflow-x: hidden

.modal-header h3
  margin-top: 0
  color: $headerColor

.modal-body
  margin: 10px 0

.modal-default-button
  float: right

.modal-enter, .modal-leave-to
  opacity: 0

.modal-leave-active
  transition: opacity .2s

.modal-enter .modal-container,
.modal-leave-active .modal-container
  -webkit-transform: scale(0.1)
  transform: scale(0.1)

.close-icon
  position: absolute
  width: 20px
  height: 20px
  right: 30px
  top: 10px
  z-index: 9999999
  color: #9e9e9e
  border-radius: 12px
  transition: opacity .2s, background .2s, color .2s
  &:hover
    opacity: 0.9
    color: grey
    cursor: pointer
  &:active
    opacity: 0.5

</style>
